<template>
  <IconTooltip
    v-if="item.enableMultiFactor"
    :contentContainerClass="$style.contentContainer"
    :iconClass="iconClass"
  >
    <p :class="$style.tooltipContent">
      This administrator, <strong>{{ getDisplayName(item) || item.email }}</strong>,
      is required to enable Multifactor Authentication.
    </p>
  </IconTooltip>
</template>

<script>
import { mapGetters } from 'vuex';
import IconTooltip from 'components/Tooltip/IconTooltip.vue';

export default {
  name: 'UserMFAIcon',

  components: {
    IconTooltip,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('ProvidersCollection', {
      getDisplayName: 'getDisplayName',
    }),

    iconClass() {
      const iconClasses = [this.$style.icon];
      if (this.item.enableMultiFactor) {
        iconClasses.push('jc-mfa-active-up', this.$style.active);
      }
      return iconClasses;
    },
  },
};
</script>

<style module>
@value (successColor) from '~css/colors.css';

.active { color: successColor; }

.contentContainer {
  left: -37px;
  top: -36px;
}

[x-placement="left"] .contentContainer {
  right: -37px;
}

.icon {
  font-size: 18px;
}
</style>
